<template>
  <generic-modal
    size="large"
    :title="$t('scolarship')"
    icon="student"
    image="/images/icons/scolarship.png"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("student finder") }}</label>
            <div class="ui blue search" ref="student_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  name="student"
                  :placeholder="$t('search student')"
                  :value="student && student.uuid ? student.name : ''"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
          </div>
          <div class="field">
            <div class="field">
              <label for>{{ $t("scolarship type") }}</label>
              <div class="ui selection dropdown" ref="type_dropdown">
                <input type="hidden" name="type" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="two fields">
          <div class="field">
            <div class="ui horizontal cards" v-if="student">
              <div class="card">
                <div class="image">
                  <img src="/images/icons/matthew.png" />
                </div>
                <div class="content">
                  <div class="header">{{ student.name }}</div>
                  <div class="meta">
                    <a>Friends</a>
                  </div>
                  <div class="description">
                    <!-- <pre>{{ student }}</pre> -->
                  </div>
                  <div
                    class="ui basic mini icon labeled button"
                    @click="edit_student"
                  >
                    <i class="edit orange icon"></i>
                    {{ $t("edit") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui message error"></div>
      </div>
    </div>
    <template v-for="(mdl, index) in student_modals">
      <component
        :is="mdl"
        :key="index"
        :student_uuid="student.uuid"
        v-on:succedded="succedded"
      ></component>
    </template>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import StudentModal from "@/modules/student/StudentModal";
import { clone } from "@/utils";
// import { v4 } from "uuid";
// import moment from "moment";

export default {
  name: "InscriptionModal",
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    period_uuid: String,
    student_uuid: String,
    student_in: Object,
    scolarship_in: Object,
  },
  computed: {},
  data() {
    return {
      student: undefined,
      scolarship_type: undefined,
      student_modals: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/student_scolarship/do-create", {
            s: vm.student.student_id,
            t: vm.scolarship_type,
          })
            .then((response) => {
              vm.$emit("succedded", response);
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
    edit_student() {
      this.student_modals.push(StudentModal);
    },
    succedded(student) {
      this.student = student;
    },
  },
  created() {
    let vm = this;

    if (vm.student_uuid) {
      local_api(vm, "post", "/student/do-get", {
        u: vm.student_uuid,
      })
        .then((student) => {
          vm.student = student;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }

    if (vm.student_in) {
      vm.student = clone(vm.student_in);
    }

    local_api(vm, "post", "/student_scolarship_type/do-get-list", {})
      .then((types) => {
        let typs = types.map((t) => {
          return { name: t.name, value: t.type_id };
        });

        window
          .jQuery(vm.$refs.type_dropdown)
          .dropdown("setup menu", { values: typs })
          .dropdown({
            onChange(value) {
              vm.scolarship_type = value;
            },
          });
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  mounted() {
    let vm = this;

    window.jQuery(this.$refs.form).form({
      fields: {
        student: ["empty"],
        type: ["empty"],
      },
    });

    window.jQuery(this.$refs.student_search).search({
      apiSettings: {
        action: "search student",
        beforeXHR: function(xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }

          return xhr;
        },
        onResponse: function(response) {
          if (!response.success) vm.$alertify.error(stringify(response.error));
          else {
            var _response = {
              results: [],
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.username,
                student: r,
              });
            });
            _response.results.push({
              title: vm.$t("new"),
              description: vm.$t("new student"),
              student: "NEW",
            });
            return _response;
          }
        },
      },
      onSelect(result) {
        if (result.student == "NEW") {
          vm.student_modals.push(StudentModal);
        } else {
          local_api(vm, "post", "/student/do-get", {
            u: result.student.uuid,
          })
            .then((response) => {
              vm.student = response;
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            })
            .finally(() => {
              vm.processing = false;
            });
        }
      },
    });
  },
  watch: {},
};
</script>
